import { configureStore } from '@reduxjs/toolkit'
import { createWrapper } from 'next-redux-wrapper'
import { apiSlice } from './apiSlice'
import { luceEGasApi } from '../features/electricAndGas/apis/luceEGasApi'
import { dealsApi } from '../features/deals/apis/dealsApi'
import { FreeCouponApi } from './api/FreeCouponApi'
import { errorLoggingApi } from '../features/errorHandling/apis/errorLoggingApi'
import { PaymentsApi } from './api/PaymentsApi'
import { subscriptionApi } from './api/subscriptionApi'
import { paymentMethodsApi } from '@/features/subscriptions/apis/paymentMethods'
import { membershipApi } from '@/features/subscriptions/apis/membership'

import auth from '../features/auth/apis/authSlice'
import service from './serviceSlice'
import request from './requestSlice'
import payment from '../features/payments/apis/paymentSlice'
import contact from '../features/tickets/apis/contactSlice'
import notification from './notificationSlice'
import theme from './themeSlice'
import translation from './translationSlice'
import progress from './progressSlice'
import thankyou from './thankyouSlice'
import countries from './countriesSlice'
import signature from './signatureSlice'
import tempUpload from './tempUploadSlice'
import promoCode from './promoCodeSlice'
import chat from '../features/chat/apis/chatSlice'

export const makeStore = () =>
  configureStore({
    reducer: {
      [apiSlice.reducerPath]: apiSlice.reducer,
      [luceEGasApi.reducerPath]: luceEGasApi.reducer,
      [dealsApi.reducerPath]: dealsApi.reducer,
      [FreeCouponApi.reducerPath]: FreeCouponApi.reducer,
      [errorLoggingApi.reducerPath]: errorLoggingApi.reducer,
      [PaymentsApi.reducerPath]: PaymentsApi.reducer,
      [subscriptionApi.reducerPath]: subscriptionApi.reducer,
      [paymentMethodsApi.reducerPath]: paymentMethodsApi.reducer,
      [membershipApi.reducerPath]: membershipApi.reducer,
      auth,
      service,
      request,
      payment,
      contact,
      notification,
      theme,
      translation,
      progress,
      thankyou,
      countries,
      signature,
      tempUpload,
      promoCode,
      chat,
    },
    middleware: (gDM) =>
      gDM().concat(
        apiSlice.middleware,
        luceEGasApi.middleware,
        dealsApi.middleware,
        FreeCouponApi.middleware,
        errorLoggingApi.middleware,
        PaymentsApi.middleware,
        subscriptionApi.middleware,
        paymentMethodsApi.middleware,
        membershipApi.middleware
      ),
  })

export const wrapper = createWrapper(makeStore)
